import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import "../../geometry.js";
import t from "../../Graphic.js";
import "../../symbols.js";
import s from "../../core/Collection.js";
import i from "../../core/Error.js";
import o from "../../core/Handles.js";
import r from "../../core/Logger.js";
import { unwrap as n, isNone as a } from "../../core/maybe.js";
import { init as l, watch as u, whenFalse as h } from "../../core/watchUtils.js";
import { property as c } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as p } from "../../core/accessorSupport/decorators/subclass.js";
import { geographicToWebMercator as d } from "../../geometry/support/webMercatorUtils.js";
import g from "../../layers/Layer.js";
import f from "../../support/actions/ActionBase.js";
import m from "../../support/actions/ActionButton.js";
import y from "../../support/actions/ActionToggle.js";
import { getDisplayedSymbol as w } from "../../symbols/support/symbolUtils.js";
import { ViewEventPriorities as F } from "../../views/input/InputManager.js";
import { highlightsSupported as v } from "../../views/support/layerViewUtils.js";
import _ from "../Feature/FeatureViewModel.js";
import { zoomToClusteredFeatures as b, browseClusteredFeatures as C, zoomToFeature as P } from "./actions.js";
import { triggerAction as E, getSelectedTarget as A, removeClusteredFeaturesForBrowsing as j, displayClusterExtent as V, browseAggregateFeatures as M } from "./actionUtils.js";
import x from "../support/AnchorElementViewModel.js";
import { GoToMixin as O } from "../support/GoTo.js";
import I from "../../symbols/SimpleFillSymbol.js";
import L from "../../geometry/Point.js";

var T = s.ofType({
  key: "type",
  defaultKeyValue: "button",
  base: f,
  typeMap: {
    button: m,
    toggle: y
  }
}),
    S = function S() {
  return [P.clone()];
},
    B = function B() {
  return [b.clone(), C.clone()];
},
    R = "esri.widgets.Popup.PopupViewModel",
    G = r.getLogger(R);

var z = /*#__PURE__*/function (_O) {
  _inherits(z, _O);

  var _super = _createSuper(z);

  function z(e) {
    var _this;

    _classCallCheck(this, z);

    _this = _super.call(this, e), _this._handles = new o(), _this._pendingPromises = new Set(), _this._fetchFeaturesController = null, _this._selectedClusterFeature = null, _this.featurePage = null, _this.actions = new T(), _this.defaultPopupTemplateEnabled = !1, _this.autoCloseEnabled = !1, _this.autoOpenEnabled = !0, _this.browseClusterEnabled = !1, _this.content = null, _this.featuresPerPage = 20, _this.featureViewModelAbilities = null, _this.featureViewModels = [], _this.highlightEnabled = !0, _this.includeDefaultActions = !0, _this.selectedClusterBoundaryFeature = new t({
      symbol: new I({
        outline: {
          width: 1.5,
          color: "cyan"
        },
        style: "none"
      })
    }), _this.title = null, _this.updateLocationEnabled = !1, _this.view = null, _this.visible = !1, _this.zoomFactor = 4, _this.zoomToLocation = null;
    return _this;
  }

  _createClass(z, [{
    key: "isLoadingFeature",
    get: function get() {
      return this.featureViewModels.some(function (e) {
        return e.waitingForContent;
      });
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      this._handles.add([l(this, ["autoOpenEnabled", "view"], function () {
        return _this2._autoOpenEnabledChange();
      }), this.on("view-change", function () {
        return _this2._autoClose();
      }), u(this, ["highlightEnabled", "selectedFeature", "visible", "view"], function () {
        return _this2._highlightFeature();
      }), u(this, "view.animation.state", function (e) {
        return _this2._animationStateChange(e);
      }), u(this, "location", function (e) {
        return _this2._locationChange(e);
      }), u(this, "selectedFeature", function (e) {
        return _this2._selectedFeatureChange(e);
      }), u(this, ["selectedFeatureIndex", "featureCount", "featuresPerPage"], function () {
        return _this2._selectedFeatureIndexChange();
      }), u(this, ["featurePage", "selectedFeatureIndex", "featureCount", "featuresPerPage, featureViewModels"], function () {
        return _this2._setGraphicOnFeatureViewModels();
      }), u(this, "featureViewModels", function () {
        return _this2._featureViewModelsChange();
      }), this.on("trigger-action", function (e) {
        return E({
          event: e,
          view: _this2.view
        });
      }), h(this, "waitingForResult", function () {
        return _this2._waitingForResultChange();
      }, !0), u(this, ["features", "view", "view.map", "view.spatialReference"], function () {
        return _this2._updateFeatureVMs();
      }), u(this, ["view.scale"], this._viewScaleChange), h(this, "visible", function () {
        return _this2.browseClusterEnabled = !1;
      }), u(this, "browseClusterEnabled", function (e) {
        return e ? _this2.enableClusterBrowsing() : _this2.disableClusterBrowsing();
      })]);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._cancelFetchingFeatures(), this._handles.destroy(), this._handles = null, this._pendingPromises.clear(), this.browseClusterEnabled = !1, this.view = null;
    }
  }, {
    key: "active",
    get: function get() {
      return !(!this.visible || this.waitingForResult);
    }
  }, {
    key: "allActions",
    get: function get() {
      var e = this._get("allActions") || new T();
      e.removeAll();
      var t = this.actions,
          s = this.defaultActions,
          i = this.defaultPopupTemplateEnabled,
          o = this.includeDefaultActions,
          r = this.selectedFeature,
          n = o ? s.concat(t) : t,
          a = r && ("function" == typeof r.getEffectivePopupTemplate && r.getEffectivePopupTemplate(i) || r.popupTemplate),
          l = a && a.actions,
          u = a && a.overwriteActions ? l : l ? l.concat(n) : n;
      return u && u.filter(Boolean).forEach(function (t) {
        return e.add(t);
      }), e;
    }
  }, {
    key: "defaultActions",
    get: function get() {
      var e;
      var t = this._get("defaultActions") || new T();
      return t.removeAll(), t.addMany(null != (e = this.selectedFeature) && e.isAggregate ? B() : S()), t;
    }
  }, {
    key: "featureCount",
    get: function get() {
      return this.features.length;
    }
  }, {
    key: "features",
    get: function get() {
      return this._get("features") || [];
    },
    set: function set(e) {
      var t = e || [];

      this._set("features", t);

      var s = this.pendingPromisesCount,
          i = this.promiseCount,
          o = this.selectedFeatureIndex,
          r = i && t.length;
      r && s && -1 === o ? this.selectedFeatureIndex = 0 : r && -1 !== o || (this.selectedFeatureIndex = t.length ? 0 : -1);
    }
  }, {
    key: "location",
    get: function get() {
      return this._get("location") || null;
    },
    set: function set(e) {
      var t = this.get("view.spatialReference.isWebMercator");
      e && e.get("spatialReference.isWGS84") && t && (e = d(e)), this._set("location", e);
    }
  }, {
    key: "pendingPromisesCount",
    get: function get() {
      return this._pendingPromises.size;
    }
  }, {
    key: "waitingForResult",
    get: function get() {
      return !(!(!!this._fetchFeaturesController || this.pendingPromisesCount > 0) || 0 !== this.featureCount);
    }
  }, {
    key: "promiseCount",
    get: function get() {
      return this.promises.length;
    }
  }, {
    key: "promises",
    get: function get() {
      return this._get("promises") || [];
    },
    set: function set(e) {
      var _this3 = this;

      if (this._pendingPromises.clear(), this.features = [], !Array.isArray(e) || !e.length) return this._set("promises", []), void this.notifyChange("pendingPromisesCount");
      this._set("promises", e), (e = e.slice(0)).forEach(function (e) {
        _this3._pendingPromises.add(e);

        var t = function t(_t) {
          _this3._pendingPromises.has(e) && _this3._updateFeatures(_t), _this3._updatePendingPromises(e);
        },
            s = function s() {
          return _this3._updatePendingPromises(e);
        };

        e.then(t, s);
      }), this.notifyChange("pendingPromisesCount");
    }
  }, {
    key: "selectedFeature",
    get: function get() {
      var e = this.features,
          t = this.selectedFeatureIndex;
      if (-1 === t) return null;
      return e[t] || null;
    }
  }, {
    key: "selectedFeatureIndex",
    get: function get() {
      var e = this._get("selectedFeatureIndex");

      return "number" == typeof e ? e : -1;
    },
    set: function set(e) {
      var t = this.featureCount;
      e = isNaN(e) || e < -1 || !t ? -1 : (e + t) % t, this._set("selectedFeatureIndex", e);
    }
  }, {
    key: "selectedFeatureViewModel",
    get: function get() {
      return this.featureViewModels[this.selectedFeatureIndex] || null;
    }
  }, {
    key: "state",
    get: function get() {
      return this.get("view.ready") ? "ready" : "disabled";
    }
  }, {
    key: "centerAtLocation",
    value: function centerAtLocation() {
      var e = this.view,
          t = A(this);

      if (!t) {
        var _s = new i("center-at-location:invalid-target-or-view", "Cannot center at a location without a target and view.", {
          target: t,
          view: e
        });

        return G.error(_s), Promise.reject(_s);
      }

      return this.callGoTo({
        target: {
          target: t,
          scale: e.scale
        }
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      this.set({
        promises: [],
        features: [],
        content: null,
        title: null,
        location: null
      });
    }
  }, {
    key: "fetchFeatures",
    value: function fetchFeatures(e, t) {
      var s = this.view;

      if (!s || !e) {
        var _t2 = new i("fetch-features:invalid-screenpoint-or-view", "Cannot fetch features without a screenPoint and view.", {
          screenPoint: e,
          view: s
        });

        return G.error(_t2), Promise.reject(_t2);
      }

      return s.fetchPopupFeatures(e, {
        event: t && t.event,
        defaultPopupTemplateEnabled: this.defaultPopupTemplateEnabled,
        signal: t && t.signal
      });
    }
  }, {
    key: "open",
    value: function open(e) {
      var t = _objectSpread(_objectSpread({
        updateLocationEnabled: !1,
        promises: [],
        fetchFeatures: !1
      }, e), {}, {
        visible: !0
      }),
          s = t.fetchFeatures;

      delete t.fetchFeatures, s && this._setFetchFeaturesPromises(t.location), this.set(t);
    }
  }, {
    key: "triggerAction",
    value: function triggerAction(e) {
      var t = this.allActions.getItemAt(e);
      t && !t.disabled && this.emit("trigger-action", {
        action: t
      });
    }
  }, {
    key: "next",
    value: function next() {
      return this.selectedFeatureIndex = this.selectedFeatureIndex + 1, this;
    }
  }, {
    key: "previous",
    value: function previous() {
      return this.selectedFeatureIndex = this.selectedFeatureIndex - 1, this;
    }
  }, {
    key: "disableClusterBrowsing",
    value: function disableClusterBrowsing() {
      j(this), this._clearBrowsedClusterGraphics();
    }
  }, {
    key: "enableClusterBrowsing",
    value: function () {
      var _enableClusterBrowsing = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return V(this);

              case 2:
                _context.next = 4;
                return M(this);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function enableClusterBrowsing() {
        return _enableClusterBrowsing.apply(this, arguments);
      }

      return enableClusterBrowsing;
    }()
  }, {
    key: "_animationStateChange",
    value: function _animationStateChange(e) {
      this.zoomToLocation || (P.disabled = "waiting-for-target" === e);
    }
  }, {
    key: "_clearBrowsedClusterGraphics",
    value: function _clearBrowsedClusterGraphics() {
      var e;
      var t = null == (e = this.view) ? void 0 : e.graphics;
      t && (t.remove(this.selectedClusterBoundaryFeature), t.remove(this._selectedClusterFeature)), this._selectedClusterFeature = null, this.selectedClusterBoundaryFeature.geometry = null;
    }
  }, {
    key: "_viewScaleChange",
    value: function _viewScaleChange() {
      var e;
      (null != (e = this.selectedFeature) && e.isAggregate || this.browseClusterEnabled) && (this.browseClusterEnabled = !1, this.visible = !1);
    }
  }, {
    key: "_locationChange",
    value: function _locationChange(e) {
      var t = this.selectedFeature,
          s = this.updateLocationEnabled;
      s && e && (!t || t.geometry) && this.centerAtLocation();
    }
  }, {
    key: "_selectedFeatureIndexChange",
    value: function _selectedFeatureIndexChange() {
      this.featurePage = this.featureCount > 1 ? Math.floor(this.selectedFeatureIndex / this.featuresPerPage) + 1 : null;
    }
  }, {
    key: "_featureViewModelsChange",
    value: function _featureViewModelsChange() {
      this.featurePage = this.featureCount > 1 ? 1 : null;
    }
  }, {
    key: "_setGraphicOnFeatureViewModels",
    value: function _setGraphicOnFeatureViewModels() {
      var e = this.features,
          t = this.featureCount,
          s = this.featurePage,
          i = this.featuresPerPage,
          o = this.featureViewModels;
      if (null === s) return;
      var r = ((s - 1) * i + t) % t,
          n = r + i;
      o.slice(r, n).forEach(function (t, s) {
        t && !t.graphic && (t.graphic = e[r + s]);
      });
    }
  }, {
    key: "_selectedFeatureChange",
    value: function () {
      var _selectedFeatureChange2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
        var _this4 = this;

        var t, s, i;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (e) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                t = this.location, s = this.updateLocationEnabled, i = this.view;

                if (!this.browseClusterEnabled) {
                  _context2.next = 11;
                  break;
                }

                if (!(this._selectedClusterFeature && (i.graphics.remove(this._selectedClusterFeature), this._selectedClusterFeature = null), e.isAggregate)) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return");

              case 6:
                _context2.next = 8;
                return w(e);

              case 8:
                e.symbol = _context2.sent;
                this._selectedClusterFeature = e;
                return _context2.abrupt("return", void i.graphics.add(this._selectedClusterFeature));

              case 11:
                !s && t || !e.geometry ? s && !e.geometry && this.centerAtLocation().then(function () {
                  _this4.location = i.center.clone();
                }) : this.location = n(this._getPointFromGeometry(e.geometry));

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _selectedFeatureChange(_x) {
        return _selectedFeatureChange2.apply(this, arguments);
      }

      return _selectedFeatureChange;
    }()
  }, {
    key: "_waitingForResultChange",
    value: function _waitingForResultChange() {
      !this.featureCount && this.promises && (this.visible = !1);
    }
  }, {
    key: "_setFetchFeaturesPromises",
    value: function _setFetchFeaturesPromises(e) {
      var _this5 = this;

      return this._fetchFeaturesWithController(this._getScreenPoint(e || this.location)).then(function (e) {
        var t = e.clientOnlyGraphics,
            s = e.promisesPerLayerView,
            i = Promise.resolve(t),
            o = s.map(function (e) {
          return e.promise;
        });
        _this5.promises = [i].concat(_toConsumableArray(o));
      });
    }
  }, {
    key: "_destroyFeatureVMs",
    value: function _destroyFeatureVMs() {
      this.featureViewModels.forEach(function (e) {
        return e && !e.destroyed && e.destroy();
      }), this._set("featureViewModels", []);
    }
  }, {
    key: "_updateFeatureVMs",
    value: function _updateFeatureVMs() {
      var _this6 = this;

      var e = this.selectedFeature,
          t = this.features,
          s = this.featureViewModels;
      if (null != e && e.isAggregate || (this.browseClusterEnabled = !1), this._destroyFeatureVMs(), !t || !t.length) return;
      var i = s.slice(0),
          o = [];
      t.forEach(function (t, s) {
        if (!t) return;
        var r = null;
        if (i.some(function (e, s) {
          return e && e.graphic === t && (r = e, i.splice(s, 1)), !!r;
        }), r) o[s] = r;else {
          var n, a;

          var _i = new _({
            abilities: _this6.featureViewModelAbilities,
            defaultPopupTemplateEnabled: _this6.defaultPopupTemplateEnabled,
            spatialReference: null == (n = _this6.view) ? void 0 : n.spatialReference,
            graphic: t === e ? t : null,
            map: null == (a = _this6.view) ? void 0 : a.map,
            view: _this6.view
          });

          o[s] = _i;
        }
      }), i.forEach(function (e) {
        return e && !e.destroyed && e.destroy();
      }), this._set("featureViewModels", o);
    }
  }, {
    key: "_getScreenPoint",
    value: function _getScreenPoint(e) {
      var t = this.view;
      return t && e && "function" == typeof t.toScreen ? t.toScreen(e) : null;
    }
  }, {
    key: "_autoOpenEnabledChange",
    value: function _autoOpenEnabledChange() {
      var _this7 = this;

      var e = "auto-fetch-features",
          t = this._handles,
          s = this.autoOpenEnabled;

      if (t.remove(e), s && this.view) {
        var _s2 = this.view.on("click", function (e) {
          "mouse" === e.pointerType && 0 !== e.button || _this7._fetchFeaturesAndOpen(e);
        }, F.WIDGET);

        t.add(_s2, e);
      }
    }
  }, {
    key: "_cancelFetchingFeatures",
    value: function _cancelFetchingFeatures() {
      var e = this._fetchFeaturesController;
      e && e.abort(), this._fetchFeaturesController = null, this.notifyChange("waitingForResult");
    }
  }, {
    key: "_fetchFeaturesWithController",
    value: function _fetchFeaturesWithController(e, t) {
      var _this8 = this;

      this._cancelFetchingFeatures();

      var s = new AbortController(),
          i = s.signal;
      this._fetchFeaturesController = s, this.notifyChange("waitingForResult");
      var o = this.fetchFeatures(e, {
        signal: i,
        event: t
      });
      return o.catch(function () {}).then(function () {
        _this8._fetchFeaturesController = null, _this8.notifyChange("waitingForResult");
      }), o;
    }
  }, {
    key: "_fetchFeaturesAndOpen",
    value: function _fetchFeaturesAndOpen(e) {
      var t = e.screenPoint,
          s = e.mapPoint,
          i = this.view;

      this._fetchFeaturesWithController(t, e).then(function (e) {
        var t = e.clientOnlyGraphics,
            o = e.promisesPerLayerView,
            r = e.location,
            n = [Promise.resolve(t)].concat(_toConsumableArray(o.map(function (e) {
          return e.promise;
        })));
        return i.popup.open({
          location: r || s,
          promises: n
        }), e;
      });
    }
  }, {
    key: "_updatePendingPromises",
    value: function _updatePendingPromises(e) {
      e && this._pendingPromises.has(e) && (this._pendingPromises.delete(e), this.notifyChange("pendingPromisesCount"));
    }
  }, {
    key: "_autoClose",
    value: function _autoClose() {
      this.autoCloseEnabled && (this.visible = !1);
    }
  }, {
    key: "_getPointFromGeometry",
    value: function _getPointFromGeometry(e) {
      return a(e) ? null : "point" === e.type ? e : "extent" === e.type ? e.center : "polygon" === e.type ? e.centroid : "multipoint" === e.type || "polyline" === e.type ? e.extent.center : null;
    }
  }, {
    key: "_getLayerView",
    value: function () {
      var _getLayerView2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e, t) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return e.when();

              case 2:
                return _context3.abrupt("return", e.whenLayerView(t));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function _getLayerView(_x2, _x3) {
        return _getLayerView2.apply(this, arguments);
      }

      return _getLayerView;
    }()
  }, {
    key: "_highlightFeature",
    value: function () {
      var _highlightFeature2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var e, t, s, i, o, r, n, a, l, u, h, c, p;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                e = "highlight";

                this._handles.remove(e);

                t = this.selectedFeature, s = this.highlightEnabled, i = this.view, o = this.visible;

                if (t && i && s && o) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return");

              case 5:
                r = t.layer, n = t.sourceLayer;

                if (!("map-notes" !== (null == n ? void 0 : n.type) && "subtype-group" !== (null == n ? void 0 : n.type) || (r = n), !(r && r instanceof g))) {
                  _context4.next = 8;
                  break;
                }

                return _context4.abrupt("return");

              case 8:
                a = this._getLayerView(i, r);
                this._highlightPromise = a;
                _context4.next = 12;
                return a;

              case 12:
                l = _context4.sent;

                if (l && v(l) && this._highlightPromise === a && this.selectedFeature && this.highlightEnabled && this.visible) {
                  _context4.next = 15;
                  break;
                }

                return _context4.abrupt("return");

              case 15:
                u = "objectIdField" in r && r.objectIdField, h = t.attributes, c = h && u && h[u], p = l.highlight(c || t);

                this._handles.add(p, e);

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _highlightFeature() {
        return _highlightFeature2.apply(this, arguments);
      }

      return _highlightFeature;
    }()
  }, {
    key: "_updateFeatures",
    value: function _updateFeatures(e) {
      var t = this.features;
      if (!e || !e.length) return;
      if (!t.length) return void (this.features = e);
      var s = e.filter(function (e) {
        return -1 === t.indexOf(e);
      });
      this.features = t.concat(s);
    }
  }]);

  return z;
}(O(x));

e([c()], z.prototype, "featurePage", void 0), e([c()], z.prototype, "isLoadingFeature", null), e([c({
  type: T
})], z.prototype, "actions", void 0), e([c({
  readOnly: !0
})], z.prototype, "active", null), e([c({
  readOnly: !0
})], z.prototype, "allActions", null), e([c({
  type: Boolean
})], z.prototype, "defaultPopupTemplateEnabled", void 0), e([c()], z.prototype, "autoCloseEnabled", void 0), e([c()], z.prototype, "autoOpenEnabled", void 0), e([c()], z.prototype, "browseClusterEnabled", void 0), e([c()], z.prototype, "content", void 0), e([c({
  type: T,
  readOnly: !0
})], z.prototype, "defaultActions", null), e([c({
  readOnly: !0
})], z.prototype, "featureCount", null), e([c()], z.prototype, "features", null), e([c()], z.prototype, "featuresPerPage", void 0), e([c()], z.prototype, "featureViewModelAbilities", void 0), e([c({
  readOnly: !0
})], z.prototype, "featureViewModels", void 0), e([c()], z.prototype, "highlightEnabled", void 0), e([c()], z.prototype, "includeDefaultActions", void 0), e([c({
  type: L
})], z.prototype, "location", null), e([c({
  readOnly: !0
})], z.prototype, "pendingPromisesCount", null), e([c({
  readOnly: !0
})], z.prototype, "selectedClusterBoundaryFeature", void 0), e([c({
  readOnly: !0
})], z.prototype, "waitingForResult", null), e([c({
  readOnly: !0
})], z.prototype, "promiseCount", null), e([c()], z.prototype, "promises", null), e([c({
  value: null,
  readOnly: !0
})], z.prototype, "selectedFeature", null), e([c({
  value: -1
})], z.prototype, "selectedFeatureIndex", null), e([c({
  readOnly: !0
})], z.prototype, "selectedFeatureViewModel", null), e([c({
  readOnly: !0
})], z.prototype, "state", null), e([c()], z.prototype, "title", void 0), e([c()], z.prototype, "updateLocationEnabled", void 0), e([c()], z.prototype, "view", void 0), e([c()], z.prototype, "visible", void 0), e([c()], z.prototype, "zoomFactor", void 0), e([c()], z.prototype, "zoomToLocation", void 0), e([c()], z.prototype, "centerAtLocation", null), z = e([p(R)], z);
var U = z;
export { U as default };